import initialState from "./initialState";

export const types = {
  reset: "reset",
  SET_ENTITIES: "SET_ENTITIES",
  SET_ENTITY_EVENTS: "SET_ENTITY_EVENTS",
  SET_STATIC_ENTITIES: "SET_STATIC_ENTITIES",
};

export default {
  /**
   * Resets the module state with initial state
   */
  [types.reset]: state => {
    Object.keys(initialState()).forEach(key => {
      state[key] = initialState()[key];
    });
  },
  [types.SET_ENTITIES]: (state, entities) => {
    state.entities = entities;
    state.entitiesById = Object.keys(entities);
  },
  [types.SET_ENTITY_EVENTS]: (state, entityEvents) => {
    state.entityEvents = entityEvents;
    state.entityEventsById = Object.keys(entityEvents);
  },
  [types.SET_STATIC_ENTITIES]: (state, entities) => {
    state.staticEntities = entities;
    state.staticEntitiesById = Object.keys(entities);
  },
};
